import React from 'react';
import { CrudStyles } from '../shared/Crud';
import { getInvoiceStatusMeta } from './invoiceStatusConfig';

const { StatusBadge } = CrudStyles;

export default function InvoiceStatusBadge({ state, compact = false }) {
    const meta = getInvoiceStatusMeta(state);
    const { label, colorToken, icon: Icon } = meta;

    return (
        <StatusBadge
            as="span"
            style={{
                ...(compact ? {} : { minWidth: '11rem' }),
                textTransform: 'none',
            }}
            $active={meta.value === 'PAID'}
            data-color-token={colorToken}
        >
            {Icon ? <Icon /> : null}
            <span>{label}</span>
        </StatusBadge>
    );
}
